<template>
    <div>
        <kgr-loading
            v-if="letter === null"
            inline
        />
        <template v-else>
            <kgr-letter-signatures-button
                :letter="letter"
                :view="viewedBy"
                @click="openModalAndStartSigning"
            />
            <kgr-letter-signatures-status
                :signatures="firstSignatures"
                :view="firstType"
            />
            <kgr-letter-signatures-status
                :signatures="secondSignatures"
                :view="secondType"
            />
        </template>

        <kgr-letter-signatures-modal
            v-if="signingStarted && letter !== null"
            :letter="letter"
            @close="closeModal"
            @saved="loadLetter"
        />
    </div>
</template>

<script>
import LetterSignaturesButton from './LetterSignaturesButton.vue';
import LetterSignaturesModal from './LetterSignaturesModal.vue';
import LetterSignaturesStatus from './LetterSignaturesStatus.vue';
import Loading from '../../common/Loading.vue';
import SignableLetterRepository from '../../../js/repository/SignableLetterRepository.js';

export default {
    components: {
        'kgr-letter-signatures-modal': LetterSignaturesModal,
        'kgr-letter-signatures-status': LetterSignaturesStatus,
        'kgr-letter-signatures-button': LetterSignaturesButton,
        'kgr-loading': Loading,
    },
    props: {
        letterId: {
            type: Number,
            required: true,
        },
        viewedBy: {
            type: String,
            validate(val) {
                return val === 'employee' || val === 'custody';
            },
            required: true,
        },
    },
    data() {
        return {
            signingStarted: false,
            letter: null,
        };
    },
    computed: {
        disabled() {
            return this.letter === null || !this.letter.isAllowedToEdit || this.letter.getSignableSignatures().length === 0;
        },
        firstType() {
            return this.viewedBy === 'employee' ? 'employee' : 'custody';
        },
        secondType() {
            return this.viewedBy === 'employee' ? 'custody' : 'employee';
        },
        firstSignatures() {
            if (this.letter === null) {
                return [];
            }
            if (this.viewedBy === 'employee') {
                return this.letter.signatures.filter((s) => s.isSignableByEmployee());
            }
            return this.letter.signatures.filter((s) => s.isSignableByCustody());
        },
        secondSignatures() {
            if (this.letter === null) {
                return [];
            }
            if (this.viewedBy === 'employee') {
                return this.letter.signatures.filter((s) => s.isSignableByCustody());
            }
            return this.letter.signatures.filter((s) => s.isSignableByEmployee());
        },
    },
    mounted() {
        this.loadLetter();
    },
    methods: {
        loadLetter() {
            this.loading = true;
            this.numSignatures = 0;
            SignableLetterRepository.find(this.letterId)
                .then((response) => {
                    this.letter = response;
                })
                .catch(() => {
                    console.error(`Failed to load signable letter with id ${this.letterId}`);
                });
        },
        openModalAndStartSigning() {
            if (this.disabled) {
                return;
            }
            this.signingStarted = true;
        },
        closeModal() {
            this.signingStarted = false;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
